import { PayPalButtons } from '@paypal/react-paypal-js';
import PayPalLogo from 'assets/icons/payment/paypal-logo.svg';
import { PdProductItem } from 'interfaces/line-item';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { MODAL_STATUS, useCartStore } from 'stores/carts';
import { showErrorToast } from 'utils/toasts';
import usePaypalExpressButton from './state';

interface PaypalExpressButtonNewProps {
  oosItems: PdProductItem[];
}

/**
 * Paypal Express Button Component
 * more info:
 * @see https://paypal.github.io/react-paypal-js/?path=/docs/example-paypalbuttons--default
 * @see https://petsdeli.atlassian.net/wiki/spaces/DOKUMENTAT/pages/2015821825/PayPal+Express+Checkout
 */
const PaypalExpressButtonNew: React.FC<PaypalExpressButtonNewProps> = ({ oosItems }) => {
  const { push } = useRouter();
  const { setModalOosStatus } = useCartStore();
  const { loading, createPaypalOrder, onPaypalApprove } = usePaypalExpressButton();

  const handleOOSClick = useCallback(() => {
    setModalOosStatus(MODAL_STATUS.PAYPAL_OPEN);
  }, [setModalOosStatus]);

  if (loading)
    return <div className="bg-grey-400 h-10 w-full grow animate-pulse rounded-full opacity-40" />;

  return (
    <div className="relative h-10 w-full grow">
      <PayPalButtons
        style={{
          height: 40,
          layout: 'horizontal',
          tagline: false,
          shape: 'pill',
        }}
        createOrder={createPaypalOrder}
        onApprove={onPaypalApprove}
        onError={(error) => {
          if (error.message === 'Detected popup close') {
            return;
          }

          console.log('Error cought via PayPal Button component - onError', error);
          push('/cart');
          showErrorToast({
            error: 'error:unknown',
            caller: 'PaypalExpressButton',
          });
        }}
      />
      {/* In oorder to have a full cusomization of the button, we need the following: */}
      <div className="bg-other-white pointer-events-none absolute inset-0 z-998">
        <div className="border-grey-200 flex h-10 items-center justify-center rounded-full border">
          <PayPalLogo />
        </div>
      </div>
      {/* In order to make the button clickable and execute another function, we need to add an overlay */}
      {oosItems.length > 0 && (
        <button className="absolute inset-0 z-999" onClick={handleOOSClick} />
      )}
    </div>
  );
};

export default PaypalExpressButtonNew;
